var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCalendarDay, faDollarSign } from '@fortawesome/pro-regular-svg-icons';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { formatCurrency, formatDisplayDate } from 'syf-js-utilities/formats';
import { formatOrdinalNumber } from '../../../../helpers/formatOrdinalNumber';
import useCurrentLanguage from '../../../../hooks/use-current-language';
import useTranslation from '../../../../hooks/use-translation';
import { StyledText } from '../../../subcomponents';
import Detail from './detail';
import { StyledMobileBorder } from './subcomponents';
var SettlementDetails = function (_a) {
    var _b;
    var settlement = _a.settlement;
    var i18n = useTranslation();
    var currentLanguage = useCurrentLanguage();
    var selectedPlan = settlement.plan, data = settlement.data;
    var isLastItem = function (index) {
        return index !== selectedPlan.installments.length - 1;
    };
    return (_jsxs(Inset, __assign({ vertical: "xxlarge" }, { children: [_jsx(StyledText, __assign({ size: "medium", weight: "light" }, { children: i18n('settlement.successDetailsHeading') })), _jsx(Stack, { size: "medium" }), _jsx(Stack, { size: "xsmall", hideOnBreakpointUp: "large" }), _jsx(StyledMobileBorder, { hideOnBreakpointUp: "large" }), _jsx(Stack, { size: "medium" }), _jsx(Detail, { icon: faDollarSign, title: i18n('settlement.successSettlementAmountText'), value: formatCurrency(data === null || data === void 0 ? void 0 : data.allowedSettlementAmount) }), _jsx(Stack, { size: "xsmall", hideOnBreakpointUp: "large" }), _jsx(StyledMobileBorder, { hideOnBreakpointUp: "large" }), _jsx(Stack, { size: "medium" }), (_b = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.installments) === null || _b === void 0 ? void 0 : _b.map(function (_a, index) {
                var amount = _a.installmentAmount, dueDate = _a.paymentDueDate;
                return (_jsxs(Inset, __assign({ bottom: "xlarge" }, { children: [_jsx(Detail, { icon: faCalendarDay, title: "".concat(i18n('settlement.successPaymentDueDateText', {
                                paymentCount: formatOrdinalNumber(index + 1)
                            })), value: formatDisplayDate(dueDate, currentLanguage) }), _jsx(Detail, { icon: faDollarSign, title: i18n('settlement.successAmountDueText'), value: formatCurrency(amount) }), isLastItem(index) && (_jsx(StyledMobileBorder, { hideOnBreakpointUp: "large" }))] }), "installment-".concat(index + 1)));
            })] })));
};
export default SettlementDetails;
//# sourceMappingURL=settlement.js.map